import { render, staticRenderFns } from "./IActionsMenu.vue?vue&type=template&id=a8ef491a&"
import script from "./IActionsMenu.vue?vue&type=script&lang=js&"
export * from "./IActionsMenu.vue?vue&type=script&lang=js&"
import style0 from "./IActionsMenu.vue?vue&type=style&index=0&id=a8ef491a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports